module.exports = __webpack_public_path__ + "static/img/xl5.8946013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl5.jpg
// module id = BEpr
// module chunks = 1